import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { formatToastError } from 'utils/formatError';

export const rtkQueryErrorLogger: Middleware = (_api: MiddlewareAPI) => next => action => {
  if (isRejectedWithValue(action)) {
    formatToastError(action.payload.data);
  }
  return next(action);
};
